import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CheckCircle2, Printer, XCircle } from "lucide-react";
import { api, errMsg, fmtDate } from "@/lib/api";
import { ErrorBox, Spinner, useFetch } from "@/components/common";
import { CouponTicket, RxSheet } from "@/components/RxSheet";

const PrintBar = () => (
  <div className="no-print mx-auto mb-4 flex max-w-[560px] justify-between">
    <button className="btn-ghost btn-sm" onClick={() => window.history.back()} data-testid="print-back"><ArrowLeft size={13} /> Back</button>
    <button className="btn-primary btn-sm" onClick={() => window.print()} data-testid="download-pdf-button"><Printer size={13} /> Download / print PDF</button>
  </div>
);

export function PrintRx() {
  const { number } = useParams();
  const { data, error } = useFetch(`/rx/prescriptions/${number}`);
  return <div className="min-h-screen bg-slate-100 p-4 print:bg-white print:p-0"><PrintBar />{error ? <ErrorBox error={error} /> : data ? <RxSheet rx={data} /> : <Spinner />}</div>;
}

export function PrintCoupon() {
  const { code } = useParams();
  const { data, error } = useFetch(`/rx/coupons/${code}`);
  return <div className="min-h-screen bg-slate-100 p-4 print:bg-white"><PrintBar /><div className="mx-auto max-w-[420px]">{error ? <ErrorBox error={error} /> : data ? <CouponTicket c={data} /> : <Spinner />}</div></div>;
}

export function VerifyRx() {
  const { number } = useParams();
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { api.get(`/public/rx/${encodeURIComponent(number)}`).then((r) => setD(r.data)).catch((e) => setError(errMsg(e))); }, [number]);
  const valid = d?.status === "VALID";
  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <div className="mx-auto max-w-md rounded-3xl bg-white p-6 shadow-xl" data-testid="verify-rx-page">
        <img src="/logo-full.png" alt="GIA care+" className="mx-auto w-32" />
        <p className="mt-2 text-center text-xs font-bold uppercase tracking-widest text-slate-400">e-RX verification</p>
        {error ? <p className="mt-6 text-center text-red-600" data-testid="verify-error">{error}</p> : !d ? <Spinner /> : (
          <div className="mt-5 space-y-4">
            <div className={`flex items-center justify-center gap-2 rounded-2xl p-4 text-2xl font-black ${valid ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-700"}`} data-testid="verify-status">
              {valid ? <CheckCircle2 size={28} /> : <XCircle size={28} />} {valid ? "VALID" : "VOIDED"}
            </div>
            {!valid && d.void_reason && <p className="text-center text-xs text-red-600">Reason: {d.void_reason}</p>}
            <div className="text-sm"><p><b className="font-mono">{d.number}</b> · {fmtDate(d.issued_at)}</p>
              <p>{d.doctor.display_name} · {d.doctor.specialty} · PRC {d.doctor.prc_no}</p><p className="text-xs text-slate-500">{d.doctor.clinic_name}</p>
              <p className="mt-1">Patient: {d.patient.initials} · Age {d.patient.age ?? "—"}</p></div>
            <ol className="space-y-2 rounded-2xl bg-slate-50 p-4 text-sm">{d.items.map((m, i) => <li key={i}><b>{m.generic} {m.strength}</b> #{m.quantity}<br /><span className="text-xs italic">Sig: {m.sig}</span></li>)}</ol>
          </div>
        )}
        <Link to="/login" className="mt-6 block text-center text-xs text-purple-700">GIAcare+ by GIA Healthcare</Link>
      </div>
    </div>
  );
}
